import React from "react";
import MainTitle from "app/components/common/typography/MainTitle";
import HeadsetIcon from "app/assets/icons/HeadsetIcon";
import EditPencil from "app/assets/icons/EditPencil";
import { useDispatch } from "react-redux";
import { setStep } from "app/lib/store/slices/steps/loanTypesSteps";
import { useSelector } from "react-redux";
import { RootState } from "app/lib/store/store";

const Declined: React.FC = () => {
  const dispatch = useDispatch();
  const { vehicleDetail, loanApplication, applicants, ...others } = useSelector(
    (state: RootState) => state.loanTypesSteps.stepsData
  );
  const isRefinance = vehicleDetail?.purchaseFrom === "Refinance";
  const handleEditApplication = () => {
    dispatch(setStep(isRefinance ? 13 : 12));
  };

  return (
    <>
      <div className="sm:mt-10">
        <div className="w-full  sm:w-[80%] xl:w-[60%]  mx-auto text-center px-4 sm:px-0">
          <MainTitle title="Oops! Declined" />

          <div className="text-left">
            <p className="text-center text-base text-[#585C7B] font-normal font-Mulish mx-auto w-[full] mb-6 ">
              Serviceability requirements not met
            </p>
            <p className="text-center text-base text-[#585C7B] font-normal font-Mulish mx-auto w-[full] sm:w-[70%]">
              Unfortunately, based on the information provided, your application
              does not fulfill the required conditions for loan
              pre-qualifications. Please contact support for further assistance
              if required.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row justify-center gap-4 my-10 px-4 sm:px-0 ">
            <button
              onClick={handleEditApplication}
              className={`w-full sm:w-[25%] flex justify-center  items-center gap-3 rounded-[8px] bg-[#EAECF0] text-[14px] text-[#98A2B3] py-3 sm:px-0 px-4 sm:py-4  transition-colors duration-300 hover:bg-[#EAECF0] hover:text-[#98A2B3] `}
            >
              <EditPencil />
              Edit Application
            </button>
            {/* <button
              className={`w-full sm:w-[33%] flex justify-center items-center gap-3 rounded-[8px] bg-primary text-[14px] text-white py-3 sm:px-0 px-4 sm:py-4  transition-colors duration-300 hover:bg-darkgrey  `}
              onClick={() => (window.location.href = "mailto:info@hejaz.com")}
            >
              <HeadsetIcon />
              Contact Support
            </button> */}
            <a
              href={`mailto:information@hejazfs.com.au`}
              className={`w-full sm:w-[33%] flex justify-center items-center gap-3 rounded-[8px] bg-primary text-[14px] text-white py-3 sm:px-0 px-4 sm:py-4  transition-colors duration-300 hover:bg-darkgrey  `}
            >
              <HeadsetIcon />
              Contact Support
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Declined;
